import { Collection, Plugin } from 'ckeditor5';
/**
 * This plugin is responsible for managing the state of the condition plugin.
 * It will keep track of all conditions in the editor and provide methods for
 * adding, removing and getting conditions.
 */
export class ConditionState extends Plugin {
    constructor() {
        super(...arguments);
        this.conditionData = new Collection();
    }
    static get pluginName() {
        return 'ConditionState';
    }
    init() {
        this.trackMarkerChanges();
        this.set('activeCondition', undefined);
    }
    trackMarkerChanges() {
        const { conversion } = this.editor;
        conversion.for('downcast').add((dispatcher) => {
            dispatcher.on('addMarker:condition-inline', (_, data) => {
                this.addCondition(data.markerName);
            });
            dispatcher.on('removeMarker:condition-inline', (_, data) => {
                this.setInDocument(data.markerName, false);
            });
        });
    }
    addCondition(id) {
        if (!id) {
            return;
        }
        const existing = this.conditionData.get(id);
        if (existing) {
            existing.inDocument = true;
            return;
        }
        this.conditionData.add({ id, inDocument: true });
    }
    setInDocument(id, inDocument) {
        const item = this.conditionData.get(id);
        if (item) {
            item.inDocument = inDocument;
        }
    }
    getCondition(id) {
        if (!id) {
            return null;
        }
        return this.conditionData.get(id);
    }
    getActiveCondition() {
        if (!this.activeCondition) {
            return {};
        }
        const parts = this.activeCondition.split(':');
        const [span, type, id, internalId] = parts;
        return {
            span,
            type,
            id,
            internalId,
        };
    }
    unsetActiveCondition() {
        this.activeCondition = undefined;
    }
    removeCondition(id) {
        this.conditionData.remove(id);
    }
}
